export const API_ROUTE = process.env.REACT_APP_API_ROUTE || "http://localhost:3030";
export const IMAGE_API_ROUTE = process.env.REACT_APP_IMAGE_API_ROUTE || "https://server.premseva.com/uploads/";

